import { gql } from '@apollo/client';

export const GET_METRICS_QUERY = gql`
  query getMetricsQuery(
    $master_list: Boolean
    $group_id: String
    $company_id: String
    $standard_ids: [String]
    $metric_group_ids: [String]
    $get_relative_standard: Boolean
  ) {
    metrics(
      master_list: $master_list
      group_id: $group_id
      company_id: $company_id
      standard_ids: $standard_ids
      metric_group_ids: $metric_group_ids
      get_relative_standard: $get_relative_standard
    ) {
      id
      deleted
      name
      description
      unit
      scope
      standard
      accumulation_method
      glo_id
      metric_group {
        id
        name
        description
      }
      reference {
        id
        path
        parentPath
      }
      esg_category
      primary_metric_calculated
      is_calculated
    }
  }
`;

export const GET_METRIC_BY_NAME_QUERY = gql`
  query getMetricByNameQuery(
    $master_list: Boolean
    $metric_group_name: String
    $metric_name: String
    $group_id: String
    $company_id: String
    $deleted: Boolean
  ) {
    metric_by_name(
      master_list: $master_list
      metric_group_name: $metric_group_name
      metric_name: $metric_name
      group_id: $group_id
      company_id: $company_id
      deleted: $deleted
    ) {
      id
      deleted
      name
      description
      unit
      scope
      standard
      glo_id
      metric_group {
        id
        name
        description
      }
    }
  }
`;

export const GET_UNCONFIGURED_METRICS_QUERY = gql`
  query getUnconfiguredMetrics(
    $group_id: String
    $company_id: String
    $standard_ids: [String]
    $get_relative_standard: Boolean
  ) {
    unconfigured_metrics(
      group_id: $group_id
      company_id: $company_id
      standard_ids: $standard_ids
      get_relative_standard: $get_relative_standard
    ) {
      id
      deleted
      name
      description
      unit
      scope
      standard
      accumulation_method
      glo_id
      metric_group {
        id
        name
        description
      }
      esg_category
      primary_metric_calculated
      is_calculated
    }
  }
`;

export const ALLOW_DELETE_METRIC_QUERY = gql`
  query allowDeleteMetric(
    $group_id: String
    $company_id: String
    $metric_id: String
    $metric_group_id: String
  ) {
    allowDeleteMetric(
      group_id: $group_id
      company_id: $company_id
      metric_id: $metric_id
      metric_group_id: $metric_group_id
    )
  }
`;
